import { render, staticRenderFns } from "./RoleCard.vue?vue&type=template&id=3e71d30e&scoped=true&"
import script from "./RoleCard.vue?vue&type=script&lang=js&"
export * from "./RoleCard.vue?vue&type=script&lang=js&"
import style0 from "./RoleCard.vue?vue&type=style&index=0&id=3e71d30e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e71d30e",
  null
  
)

export default component.exports